<template>
  <div class="mb-8">
    <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div>
        <h2 class="text-2xl sm:text-3xl font-semibold text-foreground tracking-tight">{{ title }}</h2>
        <p v-if="description" class="text-sm text-muted mt-2 max-w-2xl">{{ description }}</p>
        <div class="w-12 h-1 rounded-full bg-primary mt-4" aria-hidden="true" />
      </div>
      <div v-if="$slots.actions" class="shrink-0">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
  },
}
</script>
